<template>
    <v-flex xs11 md6 mt-6 mb-6>
        <v-btn
            block
            id="coupon-print-btn"
            @click="print()"
        >
            <v-icon small color="primary">
                fas fa-print
            </v-icon>
            <span class="pl-2">
                {{ $t('base.print') }}
            </span>
        </v-btn>
    </v-flex>
</template>

<script>

export default {
    name: 'coupon-print-button',
    methods: {
        print() {
            this.$emit('print');
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
